/**
 * Maps standardized v2 API destination fields (name, number)
 * to the service-specific fields expected by DestinationSelector.
 */
const fieldMap = {
  VOICEMAIL: { name: "fullName", number: "mailbox" },
  DISABLEUNCONDITIONALDID: { name: "diCommentName" },
  ENABLEUNCONDITIONALDID: { name: "diCommentName" },
  SETUNCONDITIONALDID: { name: "diCommentName" },
  TOGGLEUNCONDITIONALDID: { name: "diCommentName" }
};

export const mapDestinationFields = (destination) => {
  const mapping = fieldMap[destination.destType];
  if (!mapping) return destination;

  const mapped = { ...destination };
  if (mapping.name && destination.name != null) {
    mapped[mapping.name] = destination.name;
  }
  if (mapping.number && destination.number != null) {
    mapped[mapping.number] = destination.number;
  }
  return mapped;
};
